import { Country } from "./models/countries.models";
import axiosInstance from "./axios";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchCountries = async (bearerToken): Promise<Country[]> => {
  try {
    const response = await axiosInstance.get(`${apiUrl}/Geography/countries`, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch countries:", error);
    throw error;
  }
};
